<template>
  <div>
    <form @submit.prevent="submit">
      <b-row>
        <b-col sm="4">
          <b-form-group>
            <label>Tipo de envío <span style="color: red">(Requerido)</span></label>

            <b-form-select
              :state="$v.boarding.shipment_type.$dirty ? !$v.boarding.shipment_type.$error : null"
              v-model="$v.boarding.shipment_type.$model"
              :options="shipment_types"
            />
          </b-form-group>

          <b-form-group>
            <label>País Destino <span style="color: red">(Requerido)</span></label>
            <b-form-select
              @change="getPort"
              :state="$v.boarding.country.$dirty ? !$v.boarding.country.$error : null"
              v-model="$v.boarding.country.$model"
              :options="countrys"
            />
          </b-form-group>

          <b-form-group>
            <label>SPS <span style="color: red">(Requerido)</span></label>
            <b-form-input
              type="text"
              :state="$v.boarding.sps.$dirty ? !$v.boarding.sps.$error : null"
              v-model="$v.boarding.sps.$model"
              placeholder=""
            >
            </b-form-input>
          </b-form-group>

          <b-form-group label="ETD">
            <b-form-datepicker
              placeholder="dd-mm-aaaa"
              locale="es"
              id="etd"
              :state="$v.boarding.etd.$dirty ? !$v.boarding.etd.$error : null"
              v-model="$v.boarding.etd.$model"
            ></b-form-datepicker>
          </b-form-group>

          <b-form-group label="ETA">
            <b-form-datepicker
              placeholder="dd-mm-aaaa"
              locale="es"
              id="eta"
              :state="$v.boarding.eta.$dirty ? !$v.boarding.eta.$error : null"
              v-model="$v.boarding.eta.$model"
            ></b-form-datepicker>
          </b-form-group>

          <b-form-group>
            <label>Tansporte Interno <span style="color: red">(Requerido)</span></label>
            <b-form-input
              type="text"
              :state="$v.boarding.transport_company.$dirty ? !$v.boarding.transport_company.$error : null"
              v-model="$v.boarding.transport_company.$model"
              placeholder=""
            >
            </b-form-input>
          </b-form-group>
        </b-col>

        <b-col sm="4">
          <template v-if="boarding.shipment_type == 1">
            <b-form-group>
              <label>Puerto de carga <span style="color: red">(Requerido)</span></label>

              <b-form-select
                :state="$v.boarding.loading_port.$dirty ? !$v.boarding.loading_port.$error : null"
                v-model="$v.boarding.loading_port.$model"
                :options="loading_ports"
              >
              </b-form-select>
            </b-form-group>

            <b-form-group>
              <label>Fecha y Hora de Citación en Planta <span style="color: red">(Requerido)</span></label>
              <datetime
                type="datetime"
                auto
                :state="$v.boarding.shipment_date.$dirty ? !$v.boarding.shipment_date.$error : null"
                v-model="$v.boarding.shipment_date.$model"
                required
                :minute-step="10"
                aria-describedby="input-inputFechaTermino-live-feedback"
                input-class="form-control"
                class="theme-orange"
              >
              </datetime>
            </b-form-group>

            <b-form-group label="Fecha de carga">
              <datetime
                type="datetime"
                auto
                :state="$v.boarding.date_loading.$dirty ? !$v.boarding.date_loading.$error : null"
                v-model="$v.boarding.date_loading.$model"
                required
                :minute-step="10"
                aria-describedby="input-inputFechaTermino-live-feedback"
                input-class="form-control"
                class="theme-orange"
              >
              </datetime>
            </b-form-group>

            <b-form-group label="House BL">
              <b-form-input
                type="text"
                :state="$v.boarding.house_bl.$dirty ? !$v.boarding.house_bl.$error : null"
                v-model="$v.boarding.house_bl.$model"
                placeholder=""
              >
              </b-form-input>
            </b-form-group>

            <b-form-group label="BL">
              <b-form-input
                type="text"
                :state="$v.boarding.bill_loading.$dirty ? !$v.boarding.bill_loading.$error : null"
                v-model="$v.boarding.bill_loading.$model"
                placeholder=""
              >
              </b-form-input>
            </b-form-group>

            <b-form-group>
              <label>Puerto de destino <span style="color: red">(Requerido)</span></label>
              <b-form-select
                :state="$v.boarding.destination_port.$dirty ? !$v.boarding.destination_port.$error : null"
                v-model="$v.boarding.destination_port.$model"
                :options="destination_ports"
              ></b-form-select>
            </b-form-group>

            <b-form-group>
              <label>Naviera <span style="color: red">(Requerido)</span></label>
              <b-form-select
                :state="$v.boarding.shipping_line.$dirty ? !$v.boarding.shipping_line.$error : null"
                v-model="$v.boarding.shipping_line.$model"
                :options="shipping_lines"
              ></b-form-select>
            </b-form-group>

            <b-form-group label="Nombre Nave">
              <b-form-input
                type="text"
                :state="$v.boarding.vessel.$dirty ? !$v.boarding.vessel.$error : null"
                v-model="$v.boarding.vessel.$model"
                placeholder=""
              >
              </b-form-input>
            </b-form-group>

            <b-form-group label="Deposito">
              <b-form-input
                type="text"
                :state="$v.boarding.depot.$dirty ? !$v.boarding.depot.$error : null"
                v-model="$v.boarding.depot.$model"
                placeholder=""
              >
              </b-form-input>
            </b-form-group>
          </template>

          <template v-if="boarding.shipment_type == 5">
            <b-form-group>
              <label>Puerto de carga <span style="color: red">(Requerido)</span></label>

              <b-form-select
                :state="$v.boarding.loading_port.$dirty ? !$v.boarding.loading_port.$error : null"
                v-model="$v.boarding.loading_port.$model"
                :options="loading_ports"
              >
              </b-form-select>
            </b-form-group>

            <b-form-group>
              <label>Fecha y Hora de Citación en Planta <span style="color: red">(Requerido)</span></label>
              <datetime
                type="datetime"
                auto
                :state="$v.boarding.shipment_date.$dirty ? !$v.boarding.shipment_date.$error : null"
                v-model="$v.boarding.shipment_date.$model"
                required
                :minute-step="10"
                aria-describedby="input-inputFechaTermino-live-feedback"
                input-class="form-control"
                class="theme-orange"
              >
              </datetime>
            </b-form-group>

            <b-form-group>
              <label>Puerto de destino <span style="color: red">(Requerido)</span></label>
              <b-form-select
                :state="$v.boarding.destination_port.$dirty ? !$v.boarding.destination_port.$error : null"
                v-model="$v.boarding.destination_port.$model"
                :options="destination_ports"
              ></b-form-select>
            </b-form-group>

            <b-form-group>
              <label>Naviera <span style="color: red">(Requerido)</span></label>
              <b-form-select
                :state="$v.boarding.shipping_line.$dirty ? !$v.boarding.shipping_line.$error : null"
                v-model="$v.boarding.shipping_line.$model"
                :options="shipping_lines"
              ></b-form-select>
            </b-form-group>
          </template>

          <template v-if="boarding.shipment_type == 2">
            <b-form-group>
              <label>Aeropuerto de salida <span style="color: red">(Requerido)</span></label>

              <b-form-select
                :state="$v.boarding.airport_departure.$dirty ? !$v.boarding.airport_departure.$error : null"
                v-model="$v.boarding.airport_departure.$model"
                :options="airport_departures"
              ></b-form-select>
            </b-form-group>

            <b-form-group>
              <label>Aerolínea <span style="color: red">(Requerido)</span></label>
              <b-form-select
                :state="$v.boarding.air_line.$dirty ? !$v.boarding.air_line.$error : null"
                v-model="$v.boarding.air_line.$model"
                :options="air_lines"
              ></b-form-select>
            </b-form-group>

            <b-form-group label="Nombre del vuelo">
              <b-form-input
                type="text"
                :state="$v.boarding.fligth.$dirty ? !$v.boarding.fligth.$error : null"
                v-model="$v.boarding.fligth.$model"
                placeholder=""
              >
              </b-form-input>
            </b-form-group>

            <b-form-group label="BOOKING AWB">
              <b-form-input
                type="text"
                :state="$v.boarding.bl_awb.$dirty ? !$v.boarding.bl_awb.$error : null"
                v-model="$v.boarding.bl_awb.$model"
                placeholder=""
              >
              </b-form-input>
            </b-form-group>

            <b-form-group label="Vuelo de conexión">
              <b-form-select
                :state="$v.boarding.connection_fligth.$dirty ? !$v.boarding.connection_fligth.$error : null"
                v-model="$v.boarding.connection_fligth.$model"
                :options="connection_fligths"
              />
            </b-form-group>

            <b-form-group label="Routing">
              <b-form-input
                type="text"
                :state="$v.boarding.routing.$dirty ? !$v.boarding.routing.$error : null"
                v-model="$v.boarding.routing.$model"
                placeholder=""
              >
              </b-form-input>
            </b-form-group>
          </template>
        </b-col>

        <b-col sm="4">
          <template v-if="boarding.shipment_type == 1">
            <b-form-group label="Contenedor">
              <b-form-input
                type="text"
                :state="$v.boarding.containers.$dirty ? !$v.boarding.containers.$error : null"
                v-model="$v.boarding.containers.$model"
                placeholder=""
              >
              </b-form-input>
            </b-form-group>

            <b-form-group label="Número de sello">
              <b-form-input
                type="text"
                :state="$v.boarding.seal_number.$dirty ? !$v.boarding.seal_number.$error : null"
                v-model="$v.boarding.seal_number.$model"
                placeholder=""
              >
              </b-form-input>
            </b-form-group>

            <b-form-group label="Número de dus">
              <b-form-input
                type="text"
                :state="$v.boarding.dus_number.$dirty ? !$v.boarding.dus_number.$error : null"
                v-model="$v.boarding.dus_number.$model"
                placeholder=""
              >
              </b-form-input>
            </b-form-group>

            <b-form-group label="Fecha stacking">
              <b-form-input
                :state="$v.boarding.stacking_date.$dirty ? !$v.boarding.stacking_date.$error : null"
                v-model="$v.boarding.stacking_date.$model"
              >
              </b-form-input>
            </b-form-group>

            <b-form-group label="Fecha de corte">
              <b-form-input
                type="b-form-input"
                :state="$v.boarding.cut_date.$dirty ? !$v.boarding.cut_date.$error : null"
                v-model="$v.boarding.cut_date.$model"
              >
              </b-form-input>
            </b-form-group>

            <b-form-group label="Reservas de Carga / Booking">
              <b-form-input
                type="text"
                :state="$v.boarding.booking_number.$dirty ? !$v.boarding.booking_number.$error : null"
                v-model="$v.boarding.booking_number.$model"
                placeholder=""
              >
              </b-form-input>
            </b-form-group>

            <b-form-group label="Late Arrival">
              <b-form-input
                type="text"
                :state="$v.boarding.late_arrival.$dirty ? !$v.boarding.late_arrival.$error : null"
                v-model="$v.boarding.late_arrival.$model"
                placeholder=""
              >
              </b-form-input>
            </b-form-group>
          </template>

          <template v-if="boarding.shipment_type == 2">
            <b-form-group>
              <label>Fecha y Hora de Citación en Planta <span style="color: red">(Requerido)</span></label>
              <datetime
                type="datetime"
                auto
                :state="$v.boarding.shipment_date.$dirty ? !$v.boarding.shipment_date.$error : null"
                v-model="$v.boarding.shipment_date.$model"
                required
                :minute-step="10"
                aria-describedby="input-inputFechaTermino-live-feedback"
                input-class="form-control"
                class="theme-orange"
              >
              </datetime>
            </b-form-group>

            <b-form-group>
              <label>Fecha y Hora de Entrega en el Aeropuerto <span style="color: red">(Requerido)</span></label>
              <datetime
                type="datetime"
                auto
                :state="$v.boarding.date_delivery_airport.$dirty ? !$v.boarding.date_delivery_airport.$error : null"
                v-model="$v.boarding.date_delivery_airport.$model"
                required
                :minute-step="10"
                aria-describedby="input-inputFechaTermino-live-feedback"
                input-class="form-control"
                class="theme-orange"
              >
              </datetime>
            </b-form-group>

            <b-form-group>
              <label>Aeropuerto de llegada <span style="color: red">(Requerido)</span></label>

              <b-form-select
                :state="$v.boarding.airport_arrival.$dirty ? !$v.boarding.airport_arrival.$error : null"
                v-model="$v.boarding.airport_arrival.$model"
                :options="airport_arrivals"
              ></b-form-select>
            </b-form-group>
          </template>
        </b-col>
      </b-row>
    </form>
  </div>
</template>

<script>
import { bus } from "../../main";
import { required, numeric, minLength, between, requiredIf } from "vuelidate/lib/validators";

export default {
  name: "FormInformacionEmbarque",
  props: ["boarding"],
  data() {
    return {
      shipment_types: [],
      countrys: [],
      loading_ports: [],
      destination_ports: [],
      airport_departures: [],
      connection_fligths: [],
      airport_arrivals: [],
      shipping_lines: [],
      air_lines: []
    };
  },
  validations: {
    boarding: {
      shipment_type: { required },
      vessel: {},
      shipping_line: {
        required: requiredIf(function () {
          return this.boarding.shipment_type === 1;
        })
      },
      loading_port: {
        required: requiredIf(function () {
          return this.boarding.shipment_type === 1;
        })
      },
      country: { required },
      destination_port: {
        required: requiredIf(function () {
          return this.boarding.shipment_type === 1;
        })
      },
      sps: { required, numeric },
      booking_number: {},
      depot: {},
      containers: {},
      seal_number: {},
      bill_loading: {},
      house_bl: {},
      dus_number: {},
      stacking_date: {},
      cut_date: {},
      etd: {},
      eta: {},
      date_loading: {},
      air_line: {
        required: requiredIf(function () {
          return this.boarding.shipment_type === 2;
        })
      },
      bl_awb: {},
      fligth: {},
      airport_departure: {
        required: requiredIf(function () {
          return this.boarding.shipment_type === 2;
        })
      },
      connection_fligth: {},
      airport_arrival: {
        required: requiredIf(function () {
          return this.boarding.shipment_type === 2;
        })
      },
      date_delivery_airport: {
        required: requiredIf(function () {
          return this.boarding.shipment_type === 2;
        })
      },
      shipment_date: { required },
      late_arrival: {},
      transport_company: { required },
      routing: {}
    }
  },
  created() {
    bus.$on("loadSelectdEdit", (nada) => {
      this.$axios
        .get("/api/comex/companyform/get_select_port/", {
          params: {
            id_contry: this.boarding.country,
            client: this.$store.getters.user.ID_CLIENTE
          }
        })
        .then((res) => {
          this.loading_ports = res.data.loading_port_list;
          this.loading_ports.unshift({ value: "", text: "Seleccione" });

          this.destination_ports = res.data.destination_port_list;
          this.destination_ports.unshift({ value: "", text: "Seleccione" });

          this.airport_departures = res.data.airport_departure_list;
          this.airport_departures.unshift({ value: "", text: "Seleccione" });

          this.airport_arrivals = res.data.airport_arrival_list;
          this.airport_arrivals.unshift({ value: "", text: "Seleccione" });

          this.connection_fligths = res.data.connection_fligth_list;
          this.connection_fligths.unshift({ value: "", text: "Seleccione" });
        })
        .catch((error) => {
          console.log(error.response);
        });
    });
  },
  mounted() {
    this.loadDataForm();
  },
  methods: {
    saveForm() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return 0;
      } else {
        return 1;
      }
    },
    loadDataForm() {
      this.$axios
        .get("/api/comex/companyform/get_select_info_shipment/", {
          params: {
            client: this.$store.getters.user.ID_CLIENTE
          }
        })
        .then((res) => {
          this.shipment_types = res.data.shipmenttype;
          this.shipment_types.unshift({ value: "", text: "Seleccione" });

          this.countrys = res.data.country_list;
          this.countrys.unshift({ value: "", text: "Seleccione" });

          this.shipping_lines = res.data.shipping_lines_list;
          this.shipping_lines.unshift({ value: "", text: "Seleccione" });

          this.air_lines = res.data.air_line_list;
          this.air_lines.unshift({ value: "", text: "Seleccione" });
        })
        .catch((error) => {
          console.log(error.response);
        });
    },
    getPort() {
      this.$axios
        .get("/api/comex/companyform/get_select_port/", {
          params: {
            id_contry: this.boarding.country,
            client: this.$store.getters.user.ID_CLIENTE
          }
        })
        .then((res) => {
          this.loading_ports = res.data.loading_port_list;
          this.loading_ports.unshift({ value: "", text: "Seleccione" });

          this.destination_ports = res.data.destination_port_list;
          this.destination_ports.unshift({ value: "", text: "Seleccione" });

          this.airport_departures = res.data.airport_departure_list;
          this.airport_departures.unshift({ value: "", text: "Seleccione" });

          this.airport_arrivals = res.data.airport_arrival_list;
          this.airport_arrivals.unshift({ value: "", text: "Seleccione" });

          this.connection_fligths = res.data.connection_fligth_list;
          this.connection_fligths.unshift({ value: "", text: "Seleccione" });
        })
        .catch((error) => {
          console.log(error.response);
        });
    },
    submit() {}
  },
  beforeMount() {}
};
</script>

<style></style>

